import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getTenderOffersShares } from 'modules/transactions/redux/tenderOffersSharesActions';
import { getPartnerRepresentants } from 'modules/partners/redux/partnerRepresentantsActions';
import { getHoldingClasses } from 'modules/partners/redux/holdingClassActions';

export const useSocietyInitialization = (
  societyId: string,
  actualSociety: any
) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    if (!actualSociety) return;

    const initializeData = async () => {
      try {
        setIsLoading(true);
        setIsError(false);

        await Promise.all([
          dispatch(getTenderOffersShares(societyId)),
          dispatch(getPartnerRepresentants({ societyId })),
          dispatch(getHoldingClasses({ societyId: actualSociety._id })),
        ]);
      } catch (error) {
        console.error('Failed to initialize society data:', error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    initializeData();
  }, [actualSociety, societyId, dispatch]);

  return {
    isLoading,
    isError,
  };
};
